import { useState, useEffect } from 'react';

import { useDelegate } from 'contexts/delegate.context';

import {
  StyledSlider,
  StyledRail,
  StyledContent,
  StyledTrack,
  StyledLabel
} from './slider.style';

const Slider = () => {
  const [proc, setProcent] = useState('0');
  const { procent, poolLimit } = useDelegate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (procent) {
        setProcent(procent);
      }
    }, 250);

    return () => clearTimeout(timeout);
  }, [procent]);

  return (
    <StyledSlider>
      <StyledContent>
        <StyledRail />
        <StyledTrack width={proc} />
      </StyledContent>
      <StyledLabel>{poolLimit}</StyledLabel>
    </StyledSlider>
  );
};

export default Slider;
